<div class="banner" *ngIf="IsAd && MainAD">
    <img src="{{MainAD.image_url}}" *ngIf="IsMobile" (click)="OpenUrl(MainAD)"/>
    <img src="{{MainAD.image_url}}" *ngIf="!IsMobile" (click)="OpenUrl(MainAD)"/>
    <div class="close" (click)="closeAd()">
        <i class="icon icon-close">&#xe802;</i>
    </div>
</div>

<div class="raw mainSlider">
    <div class="col-12 tab-bar">
        <div class="tab">
            <a routerLink="/home">
                <label>熱門產業</label>
            </a>
            
            <label class="active">買主地區</label>
        </div>
        <a routerLink="/sort">
            <div class="more">所有產業類別</div>
        </a>
    </div>

    <div class="col-12 tab-direct">
        <div class="before" id="before"><i class="icon icon-circle-arrow-left">&#xe80b;</i>上一個</div><div class="next" id="next">下一個<i class="icon icon-circle-arrow-right">&#xe80c;</i></div>
    </div>
    

    <div class="col-12 animated fadeIn">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="item swiper-slide" data-id="0">
                    <div class="imgbox">
                        <img src="../assets/images/earth1.png"/>
                    </div>
                    <label class="area">大洋洲</label>
                </div>
                <div class="item swiper-slide" data-id="1">
                    <div class="imgbox">
                        <img src="../assets/images/earth2.png"/>
                    </div>
                    <label class="area">亞洲</label>
                </div>
                <div class="item swiper-slide" data-id="2">
                    <div class="imgbox">
                        <img src="../assets/images/earth3.png"/>
                    </div>
                    <label class="area">美洲</label>
                </div>
                <div class="item swiper-slide" data-id="3">
                    <div class="imgbox">
                        <img src="../assets/images/earth4.png"/>
                    </div>
                    <label class="area">歐洲</label>
                </div>
              </div>
          </div>
    </div>
    
</div>

<div class="raw main">
    <div class="col-12">
        <div class="col-3 left">

            <left-select></left-select>
            
            <div class="block" *ngIf="!IsMobile">
                <ng-container *ngFor="let item of SideAD">
                    <img src="{{item.image_url}}" (click)="OpenUrl(item)"/>
                </ng-container>
                <img *ngIf="Isinfo" src="../assets/images/left4.png"/>
            </div>
        </div>
        <div class="col-9 right">
            <div class="news" *ngIf="NewsData">
                <label>最新消息</label>
                <ul id="marquee" class="marquee">
                    <ng-container *ngFor="let item of NewsData">
                        <li>
                            <a href="{{item.url}}" target="_blank">{{item.text}}</a>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div class="case">
                <h1>熱門採購案 </h1>
                <div class="content animated fadeIn" *ngIf="HotData">

                    <ng-container *ngFor="let item of HotData">

                        <div class="card {{item.statusClass}}">
                            <div class="item" routerLink="/activity/{{item.id}}">
                                <div class="status"><span>{{item.statusName}}</span></div>
                                <span class="date {{(item.is_new) ? 'lasted' : ''}}">{{item.eventShortDate}}</span>
                                <label>{{item.name}}</label>
                                <p>
                                    <span class="date">報名日期｜{{item.enrollDate}}</span>
                                    <span class="info">{{item.typeName}}</span>
                                </p>
                                <a routerLink="/activity/{{item.id}}"><span class="view">查看詳情</span></a>
                            </div>
                        </div>

                    </ng-container>

                    <empty *ngIf="HotData.length == 0"></empty>
                </div>
            </div>
        </div>

        <div class="col-3 left" *ngIf="IsMobile">
            <div class="block">
                <ng-container *ngFor="let item of SideAD">
                    <img src="{{item.image_url}}" (click)="OpenUrl(item)"/>
                </ng-container>
                <img *ngIf="Isinfo" src="../assets/images/left4.png"/>
            </div>
        </div>
    </div>
    
</div>